import { AsyncPipe } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { InstrumentType } from '@zero/shared/util-models';
import { StatisticsFacade } from '@zero/statistics/domain';
import { TradeTickerComponent } from '../trade-ticker/trade-ticker.component';

@Component({
  selector: 'statistics-trade-ticker-by-instrument-type',
  templateUrl: './trade-ticker-by-instrument-type.component.html',
  imports: [TradeTickerComponent, AsyncPipe],
})
export class TradeTickerByInstrumentTypeComponent implements OnInit {
  public readonly statisticsFacade: StatisticsFacade = inject(StatisticsFacade);

  public instrumentType = input<InstrumentType>();

  ngOnInit(): void {
    this.statisticsFacade.loadTradeTicker();
    this.statisticsFacade.toggleTradeTickerFilter(this.instrumentType());
  }
}
